import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-captura-ponto',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-captura-ponto.component.html',
  styleUrls: ['../../shared/modal-pesquisa-lista.component.css', './modal-captura-ponto.component.css']
})
export class ModalCapturaPontoComponent {
  @Input() aberta = false;
  @Input() carregando = false;
  @Input() url = '';
  @Input() titulo = 'Captura facial';
  @Input() aviso = '';
  @Input() erro = '';

  @Output() fechar = new EventEmitter<void>();
}
